//https://spin.atomicobject.com/2021/12/20/securing-api-gateway-aws-iam/
import { Sha256 } from '@aws-crypto/sha256-js';
import { HttpRequest } from '@aws-sdk/protocol-http';
import { SignatureV4 } from '@aws-sdk/signature-v4';
export const signRequest = async ({ headers, method, path, body, apiUrl, region, credentials }) => {
    const request = new HttpRequest({
        body: body ? JSON.stringify(body) : undefined,
        headers,
        hostname: apiUrl.hostname,
        method: method.toUpperCase(),
        path,
    });
    const signer = new SignatureV4({
        region,
        credentials,
        service: 'execute-api',
        sha256: Sha256,
        applyChecksum: true, // although postman does not send x-amz-content-sha256 on get
    });
    const signedRequest = await signer.sign(request, {
        unsignableHeaders: new Set(['x-amz-content-sha256', 'content-type']),
        // signableHeaders:  new Set( ['host'])
    });
    return signedRequest;
};
